import { render } from "./ActionFailure.vue?vue&type=template&id=3c86fc78&scoped=true"
import script from "./ActionFailure.vue?vue&type=script&lang=js"
export * from "./ActionFailure.vue?vue&type=script&lang=js"

import "./ActionFailure.vue?vue&type=style&index=0&id=3c86fc78&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c86fc78"]])

export default __exports__